import { createAuthUrl, getCurrentHost, AuthEndpoints } from "./endpointUtils";

export function login(redirectTo?: string) {
  window.location.assign(createAuthUrl(getCurrentHost(), AuthEndpoints.SIGN_IN, redirectTo));
}
